import { Component, HostListener, OnInit, QueryList, ViewChildren } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Cliente } from "../cadastro/cliente";
import { ClienteService } from "../cadastro/service/cliente.service";
import { EnumSolicitacaoCompraTipoFrete } from "../enum-types/enum-solicitacao-compra-tipo-frete";
import { JwtService } from "../jwt.service";
import { CotacaoManager } from "../managers/cotacao-manager";
import { OrderList } from '../order-list/order-list';
import { SolicitacaoCompraFornecedor } from '../persistences/solicitacao-compra-fornecedor';
import { Configuracoes } from "../services/configuracoes.service";
import { CotacaoService } from "../services/cotacao.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DialogParcelaConfirmacaoComponent } from "../components/genericos/dialog-parcela-confirmacao/dialog-parcela-confirmacao.component";
import { MatDialog } from "@angular/material/dialog";
import { ItemCotacaoComponent } from "../item-cotacao/Item-cotacao.component";
import { CORE_IMPORTS } from "../providers/module-providers";
import { NgxPaginationModule } from "ngx-pagination";

@Component({
	selector: "app-cotacao",
	standalone: true,
	templateUrl: "./cotacao.html",
	styleUrls: [ "./cotacao.css", "../app.component.css" ],
	imports: [CORE_IMPORTS, ItemCotacaoComponent, NgxPaginationModule]
}
)

export class CotacaoComponent implements OnInit {
	@ViewChildren(ItemCotacaoComponent) itensCotacao: QueryList<ItemCotacaoComponent>;
	solicitacao: CotacaoManager;
	allExpandState = true;
	ol: OrderList;
	showOl = false;
	innerWidth: number = window.innerWidth;
	solicitacaoCompraFornecedor:SolicitacaoCompraFornecedor;				
	tiposDeFrete = Object.keys(EnumSolicitacaoCompraTipoFrete).filter(key => !isNaN(Number(EnumSolicitacaoCompraTipoFrete[key])));
	page = 1;
	dataDigitada = '';

	mensal = false;
	formaPagamento: string;
	numeroParcelas: number;
	dataInicial: Date;
	intervaloEmDias: number;
	valorTotal: number;
	datasPagamento: string[] = [];
	datasPagamentoComBarra: string[] = [];
	valoresParcela: number;
	valoresParcelas: number[] = [];
	idSolicitacaoCompra: number;
	formulario: FormGroup;
	clienteLogado: Cliente;

	constructor(
		
		public cotacaoService: CotacaoService,
		public clienteService: ClienteService,
		public router: Router,
		private route: ActivatedRoute,
		public snackBar: MatSnackBar,
		public configuracoes: Configuracoes,
		private jwtService: JwtService,
		private fb: FormBuilder,
		private dialog: MatDialog
	) {
		this.solicitacao = 
			new CotacaoManager(
				this.clienteLogado,
				cotacaoService,
				clienteService,
				router,
				snackBar,
				configuracoes,
				jwtService
			);
		this.solicitacaoCompraFornecedor = new SolicitacaoCompraFornecedor();

		this.formulario = this.fb.group({
			numeroParcelas: [1, [Validators.required, Validators.min(1)]],
			dataInicial: ['', [Validators.required, this.dateValidator]],
			mensal: [false],
			intervaloEmDias: ['1', [Validators.min(1)]],
			tipoFrete: [null, Validators.required],
			dataValidade: ['', [Validators.required, this.dateValidator]],
			dataFaturamento: ['', [Validators.required, this.dateValidator]],
			dtPrevEntregaPadrao: ['', this.dateValidatorOpcional]
		});

		this.solicitacao.variavelModificada.subscribe(r => {
			for(let i = 0; i < this.valoresParcelas.length; i++){
				this.valoresParcelas[i] = this.solicitacao.cotacao.parcelas[i].vlVcto;
			}
		})
	}

	validarDataInicial( value: string ) { 
		const partesData = value.split('/');
		const dataInicial = new Date(parseInt(partesData[2]),parseInt(partesData[1]),parseInt(partesData[0])); 
		if(isNaN(dataInicial.getTime())){
			return false;
		}
		if ((dataInicial.getFullYear() < 1899) || (dataInicial.getFullYear() >= 2200)){
			return false;
		}
		return true;
	}  

	calcularProjecao() {
		if (this.formulario.valid) {
			this.datasPagamento = [];
			this.datasPagamentoComBarra = [];
			this.valoresParcelas = [];
			const dataParts = this.formulario.get('dataInicial').value.split('/');

			const dataInicial = new Date(parseInt(dataParts[2]), parseInt(dataParts[1])-1, parseInt(dataParts[0]));
			const hoje = new Date(dataInicial);
			const numeroParcelas = this.formulario.get('numeroParcelas').value;
			const mensal = this.formulario.get('mensal').value;
			const intervaloEmDias = this.formulario.get('intervaloEmDias').value || 30;
			const valorTotal = this.solicitacao.cotacao.vlTotal;

			const valorParcela = valorTotal / numeroParcelas;
			const valorParcelaArredondado = this.arredondarValor(valorParcela);

			for (let i = 0; i < numeroParcelas; i++) {
				const dataParcela = new Date(hoje);

				if (mensal) {
				dataParcela.setMonth(dataParcela.getMonth() + i);
				} else {
				dataParcela.setDate(dataParcela.getDate() + i * intervaloEmDias);
				}

				while (dataParcela.getDay() === 0) {
				dataParcela.setDate(dataParcela.getDate() + 1);
				}

				const valorAtual = i === numeroParcelas - 1 ? this.arredondarValor(valorTotal - (numeroParcelas - 1) * valorParcelaArredondado) : valorParcelaArredondado;
				this.valoresParcelas.push(valorAtual);
				this.datasPagamento.push(this.formatarData(dataParcela));
				this.datasPagamentoComBarra.push(this.formatarDataComBarra(dataParcela));
			}
			this.setParcelas();
		}
	}
  
	setParcelas(){
		let i;
		const parcelas = [];
		for(i = 0; i < this.datasPagamento.length; i++){
			const parcela = {
				"dtVcto": this.datasPagamentoComBarra[i],
				"nrParcela": i+1,
				"vlVcto": this.valoresParcelas[i],
				"dtVctoFormatada": this.datasPagamentoComBarra[i],
			}
			parcelas.push(parcela)
		}
		this.solicitacao.cotacao.parcelas = parcelas;
	}
	arredondarValor(valor: number): number {    
		return Math.round(valor * 100) / 100;
	}

	formatarData(data: Date): string {
		const dia = data.getDate().toString().padStart(2, '0');
		const mes = (data.getMonth() + 1).toString().padStart(2, '0');
		const ano = data.getFullYear();
		return `${dia}-${mes}-${ano}`;
	}

	formatarDataComBarra(data: Date): string {
		const dia = data.getDate().toString().padStart(2, '0');
		const mes = (data.getMonth() + 1).toString().padStart(2, '0');
		const ano = data.getFullYear();
		return `${dia}/${mes}/${ano}`;
	}

	changeCheckbox(){
		this.mensal = !this.mensal;
	}

	@HostListener('window:resize')
	onResize() {
		this.innerWidth = window.innerWidth;
	}

	ngOnInit() {
		this.jwtService.validarAcessToken();	
		this.solicitacao.init(
			this.route.snapshot.params["cdFilial"],
			this.route.snapshot.params["nrSolicitacao"]			
		)
		this.solicitacao.load();		
		this.ol = new OrderList(["Descrição", "Cod. Fabricante", "Marca"]);
		
		setTimeout(()=>{
			if (this.solicitacao.cotacao?.ordenacaoPortal) {
				for(const escolhido of this.solicitacao.cotacao.ordenacaoPortal.split(', ')){
					this.ol.add(escolhido);
					this.ordena();
				}
				this.atualizarDtPrevEntregaItens();
			}
		}, 1000);
		
	}
	
	recebeFeedback(recalcularItem: string) {
		const l = recalcularItem.split("-", 2);
		this.solicitacao.recalculaItemById(l[0], (l[1]=="true"));
	}

	recebeFeedbackSalvar(recalcularItem: string) {
		this.solicitacao.salvarItemById(recalcularItem);
	}

	setDivVisible () {
		let $;

		$("div.search-nav").css("width", "100%");
		$("div.search-nav").css("left", "0");
	}


	get olStyle () {
		return {
			'visibility': this.showOl ? 'visible' : 'hidden',
			'opacity': this.showOl ? '1' : '0'
		};
	}
	

	get appContentStyle () {
		return {
			'opacity': this.showOl ? '0.5' : '1'
		};
	}

	
	mostrarTresCampos (): boolean {
		return this.innerWidth > 1150;
	}


	mostrarUmCampo(): boolean {
		return this.innerWidth > 630;
	}


	ordena () {
		this.solicitacao.ordenaItens(
			(this.ol.listaEscolhido[0] == undefined ? "" : this.ol.listaEscolhido[0]),
			(this.ol.listaEscolhido[1] == undefined ? "" : this.ol.listaEscolhido[1]),
			(this.ol.listaEscolhido[2] == undefined ? "" : this.ol.listaEscolhido[2])
		);
	}

	
	getPesoColunaCabecalho () {
		if (innerWidth > 1330) {
			return 10;
		}
		if (innerWidth > 900) {
			return 10;
		}
		if (innerWidth > 500) {
			return 10;
		}
		else {
			return 10;
		}
	}

	//Esconde os campos nivel 1
	esconder1(): boolean {
		return this.innerWidth < 900;
	}

	//Esconde os campos nivel 2
	esconder2(): boolean {
		return this.innerWidth < 500;
	}

	getPesoCampoCabecalho (campo: string) {
		switch (campo) {
			// Peso do campo Código
			case "codigo": {
				if (this.esconder2()) {
					return 33;
				}
				if (this.esconder1()) {
					return 25;
				}
				return 20;
			}

			// Peso do campo Cd. Fabricante
			case "cdfabricante": {
				if (this.esconder2()) {
					return 33;
				}
				if (this.esconder1()) {
					return 25;
				}
				return 20;
			}

			// Peso do campo Descrição
			case "descricao": {
				return 20;
			}
				
			// Peso do campo Marca
			case "marca": {
				return 13;
			}

			// Peso do campo NCM
			case "ncm": {
				return 10;
			}

			// Peso do campo Fornecedor
			case "cdFornecedor": {
				if (this.esconder1()) {
					return 25;
				}
				return 10;
			}

			// Peso do campo Quantidade
			case "qtde": {
				if (this.esconder2()) {
					return 33;
				}
				if (this.esconder1()) {
					return 25;
				}
				return 7;
			}
			
			// Parâmetro indefinido
			default: { 
				return 10; 
			} 
		}
	}
	
	logout() {
		this.jwtService.logout();
	}

    formatarDataValidade(input: string){
		this.solicitacao.cotacao.dtValidade = this.formatarDataComBarras(input);
		this.formulario.get('dataValidade').setValue(this.formatarComoData(input));
	}

	formatarDataFaturamento(input: string){
		this.solicitacao.cotacao.dtFaturamento = this.formatarDataComBarras(input);
		this.formulario.get('dataFaturamento').setValue(this.formatarComoData(input));
	}

	formatarDtPrevEntregaPadrao(input: string){
		this.formatarDataComBarras(input);
		this.formulario.get('dtPrevEntregaPadrao').setValue(this.formatarComoData(input));
	}

	formatarDataVcto(input: string, i: number) {
		this.solicitacao.cotacao.parcelas[i].dtVctoFormatada = this.formatarDataComBarras(input);
	}

	
	formatarDataParcela(input: string, i: number) {
		this.datasPagamentoComBarra[i] = this.formatarDataComBarras(input);
		this.setParcelas();
	}
	
	formatarDataInicialPgto(input: string,) {
		this.formulario.get('dataInicial').setValue(this.formatarComoData(input));
	}

	formatarDataComBarras(input: string): string {
		const maxLength = 10;
		const formattedInput = input
			.replace(/\D/g, '')
			.slice(0, maxLength);

		if (formattedInput.length >= 1) {
			this.dataDigitada =
				formattedInput.slice(0, 2) +
				(formattedInput.length >= 4
					? '/' + formattedInput.slice(2, 4)
					: '') +
				(formattedInput.length >= 8 ? '/' + formattedInput.slice(4, 8) : '');
			return this.dataDigitada;
		} 
	}

	formatarComoData(input: string): string {
		if (!input) return '';
	
		// Remove todos os caracteres não numéricos da string
		const numeros = input.replace(/\D/g, '');
		if (numeros.length === 4) {
			const dia = numeros.substring(0, 2);
			const mes = numeros.substring(2, 4);
			return `${dia}/${mes}`;
		}
		// Se a string for mais curta que 8 caracteres, não é possível formatar como data
		if (numeros.length < 8) return input;
	
		// Divide a string em dia, mês e ano
		const dia = numeros.substring(0, 2);
		const mes = numeros.substring(2, 4);
		const ano = numeros.substring(4);
	
		// Retorna a data formatada como dd/mm/aaaa
		return `${dia}/${mes}/${ano}`;
	}

	validarCamposParcela(){
		const valorCotacaoValid = this.solicitacao.cotacao.vlTotal > 0;
		const formValid = this.formulario.valid;
		const dataValid = this.validarDataInicial(this.formulario.get('dataInicial').value)
		if(formValid && dataValid && valorCotacaoValid){
			return false;
		} else return true;
	}

	openDialogCalcularProjecao(){
		if(this.solicitacao.cotacao.parcelas){
			if(this.datasPagamentoComBarra.length <= 0 && this.solicitacao.cotacao.parcelas.length <= 0 && !this.solicitacao.possuiParcelas){
				this.calcularProjecao();
			} else{
				const dialogRef = this.dialog.open(DialogParcelaConfirmacaoComponent, {data: {message: 'Essa cotação já possui parcelas e serão substituidas, deseja confirmar?'} })
				dialogRef.afterClosed().subscribe(result => {
					if(result === 'Cancelar'){
						return
					} else if(result === 'Confirmar'){
						this.calcularProjecao();
					}
				})
			}
		} else{
			this.calcularProjecao();
		}
	}

	openDialogExcluirParcelas(){
		if(this.datasPagamentoComBarra.length <= 0 && this.solicitacao.cotacao.parcelas.length <= 0 && this.solicitacao.possuiParcelas){
			this.calcularProjecao();
		} else{
			const dialogRef = this.dialog.open(DialogParcelaConfirmacaoComponent, {data: {message: 'Deseja excluir todas as parcelas da cotação'} })
			dialogRef.afterClosed().subscribe(result => {
				if(result === 'Cancelar'){
					return
				} else if(result === 'Confirmar'){
					this.excluirParcelas()
				}
			})
		}
	}

	habilitarExclusaoDeParcelas(){
		if(this.datasPagamentoComBarra.length > 0 && this.solicitacao.cotacao.parcelas.length > 0 || this.solicitacao.possuiParcelas){
			return false;
		}
		return true;
	}

	excluirParcelas(){
		this.datasPagamentoComBarra = [];
		this.solicitacao.cotacao.parcelas =[];
		this.solicitacao.possuiParcelas = false;
	}

	dateValidator(control){
		if(control.value == null) {
			return
		}
		const numeros = control.value.replace(/\D/g, '');
		const dia = numeros.substring(0, 2);
		const mes = numeros.substring(2, 4);
		const ano = numeros.substring(4);
		const currentDate = new Date();
		currentDate.setHours(0, 0, 0, 0);
		const inputDate = new Date(ano,mes-1,dia)
		return inputDate >= currentDate ? null : { 'dateNotValid': true };
	}

	dateValidatorOpcional(control){
		if(control.value == null || control.value === '') {
			return null;
		}
		const numeros = control.value.replace(/\D/g, '');
		if (numeros.length < 8) {
			return { 'dateNotValid': true };
		}
		const dia = parseInt(numeros.substring(0, 2), 10);
		const mes = parseInt(numeros.substring(2, 4), 10);
		const ano = parseInt(numeros.substring(4, 8), 10);
		const data = new Date(ano, mes - 1, dia);
		const dataExiste =
			data.getFullYear() === ano &&
			data.getMonth() === mes - 1 &&
			data.getDate() === dia;
		if (!dataExiste) {
			return { 'dateNotValid': true };
		}
		const currentDate = new Date();
		currentDate.setHours(0, 0, 0, 0);
		return data >= currentDate ? null : { 'dateNotValid': true };
	}

	atualizaVlPristino(){
		let valorTotalParcelas;
		valorTotalParcelas = 0;
		this.solicitacao.cotacao.parcelas.forEach( p => {
			if(typeof p.vlVcto === 'string'){
				p.vlVcto = parseFloat(p.vlVcto);
			}
			valorTotalParcelas += p.vlVcto;
		})
		valorTotalParcelas = parseFloat(valorTotalParcelas.toFixed(2));

		if(valorTotalParcelas === this.solicitacao.cotacao.vlTotal){
			this.solicitacao.vlTotalPristino = this.solicitacao.cotacao.vlTotal;
		}
	}

	salvar() {
		const temErroSt = this.itensCotacao.some(item => item.isStInvalid());

		if (temErroSt) {
			this.snackBar.open('Preencha o CST Origem para todos os itens que possuem Aliq. ST ou Aliq. ICMS.', 'Fechar', { duration: 3000 });
			return;
		}

		const temErroData = this.itensCotacao.some(item => item.formDataPrevisaoEntregaInvalida());
		if (temErroData) {
			this.snackBar.open('Data de previsão de entrega inválida', 'Fechar', { duration: 3000 });
			return;
		}

		if (this.formulario.get('dtPrevEntregaPadrao')?.invalid) {
			this.snackBar.open('Dt. prev. entrega padrão inválida.', 'Fechar', { duration: 3000 });
			return;
		}

		this.solicitacao.send(this.ol.listaEscolhido);
	}

	finalizar(){
		const temErroSt = this.itensCotacao.some(item => item.isStInvalid());

		if (temErroSt) {
			this.snackBar.open('Preencha o CST Origem para todos os itens que possuem Aliq. ST ou Aliq. ICMS.', 'Fechar', { duration: 3000 });
			return;
		}

		const temErroData = this.itensCotacao.some(item => item.formDataPrevisaoEntregaInvalida());
		if (temErroData) {
			this.snackBar.open('Data de previsão de entrega inválida', 'Fechar', { duration: 3000 });
			return;
		}

		if (this.formulario.get('dtPrevEntregaPadrao')?.invalid) {
			this.snackBar.open('Dt. prev. entrega padrão inválida.', 'Fechar', { duration: 3000 });
			return;
		}

		this.solicitacao.finaliza();
	}

	isDataValida(dataStr) {
		if(dataStr == null || dataStr.trim() == ''){
			return false;
		}
		const regex = /^\d{2}\/\d{2}\/\d{4}$/;
		if (!regex.test(dataStr)) return false;
		const [dia, mes, ano] = dataStr.split('/').map(Number);
		const data = new Date(ano, mes - 1, dia);
		const dataExiste =
			data.getFullYear() === ano &&
			data.getMonth() === mes - 1 &&
			data.getDate() === dia;

		if (!dataExiste) return false;
		const hoje = new Date();
		hoje.setHours(0, 0, 0, 0);
		return data >= hoje;
	}

	aplicarDtPrevEntregaPadraoAosItens(){
		const ctrl = this.formulario.get('dtPrevEntregaPadrao');
		if(ctrl == null || ctrl.invalid){
			return;
		}
		const dtPadrao = ctrl.value;
		if(!this.isDataValida(dtPadrao)){
			return;
		}
		const originaisVazios = new Set(
			(this.solicitacao.itensFiltroOriginal ?? [])
				.filter(o => !this.isDataValida(o.dtPrevisaoEntrega))
				.map(o => o.idGeral)
		);
		this.solicitacao.itensFiltro.forEach((i) => {
			const vlBruto = i.vlBruto ?? 0;
			if(vlBruto > 0 && originaisVazios.has(i.idGeral)){
				i.dtPrevisaoEntrega = dtPadrao;
			}
		});
		this.itensCotacao.forEach(comp => {
			const vlBrutoStr = comp.form.get('vlBruto')?.value;
			const vlBruto = parseFloat((vlBrutoStr ?? '0').toString().replace(',', '.')) || 0;
			if(vlBruto > 0 && originaisVazios.has(comp.cot.idGeral)){
				comp.atualizarDtPrevisaoEntrega(dtPadrao);
			}
		});
	}

	atualizarDtPrevEntregaItens(){
		const dtPrevEntrega = this.acrescentarDiasData(
			this.solicitacao.cotacao.dtFaturamento,
			this.solicitacao.cotacao.diasPrevEntrega
		);
		if(dtPrevEntrega != 'NaN/NaN/NaN' ){
			if(this.solicitacao.cotacao.diasPrevEntrega != null && this.solicitacao.cotacao.diasPrevEntrega > 0){
				this.solicitacao.itensFiltro.forEach((i) => {
					if(!this.isDataValida(i.dtPrevisaoEntrega)){
						i.dtPrevisaoEntrega = dtPrevEntrega;
					}	
				})
			}
			this.itensCotacao.forEach(comp => {
				if(!this.isDataValida(comp.form.get('dtPrevisaoEntrega')?.value)){
					comp.atualizarDtPrevisaoEntrega(dtPrevEntrega);
				}
			});
		}
	}

	acrescentarDiasData(dataStr, dias) {
		const [dia, mes, ano] = dataStr.split('/').map(Number);
		const data = new Date(ano, mes - 1, dia);
		data.setDate(data.getDate() + dias);
		const novoDia = String(data.getDate()).padStart(2, '0');
		const novoMes = String(data.getMonth() + 1).padStart(2, '0');
		const novoAno = data.getFullYear();
		return `${novoDia}/${novoMes}/${novoAno}`;
	}
}
